module.exports = __webpack_public_path__ + "static/media/ic-home-massage.37eee6a5.svg";